import React from 'react';
import VendorDetailsFields from './VendorDetailsFields';

function ViewVendor({ VendorData }) {
  return (
    <div className="card-body px-0">
      <VendorDetailsFields formData={VendorData || {}} readOnly />
    </div>
  );
}

export default ViewVendor;
